import ArrowForward from '@material-ui/icons/ArrowForward';
import React, { useCallback, useEffect } from 'react';
import { ButtonOne } from '../../../components/ButtonOne/ButtonOne.component';
import TooltipOne from '../../../components/TooltipOne/TooltipOne.component';
import { useStyles } from '../RGZButtons.styles';
import { VerificationState } from '../Assessment.types';

interface PropsSendbackRGZButton {
  buttonType: 'multiple' | 'single';
  isDisabled?: boolean;
  isSpecialCaseReported?: boolean;
  examTaskGroupSolutionScoreIds?: string[];
  sendbackFunction?: (ids: string[]) => void;
  verificationState?: VerificationState | null;
  isVerifierBlocked?: boolean;
}

const SendbackRGZButton: React.FC<PropsSendbackRGZButton> = (props) => {
  const classes = useStyles();

  const buttonText = props.buttonType === 'multiple' ? 'Odeślij ocenione RGZ' : 'Odeślij';

  const getTooltipTitle = () => {
    if (props.isSpecialCaseReported) return 'Rozwiąż szczególny przypadek, by móc odesłać kartę';
    if (props.verificationState === VerificationState.scoreSelected)
      return 'Praca zweryfikowana - zatwierdzona przez PZE';
    if (props.isVerifierBlocked) return 'Nie możesz odesłać pracy ponieważ zostałeś zablokowany';
    return '';
  };

  const handleClick = useCallback(() => {
    props.sendbackFunction &&
      props.sendbackFunction(props.examTaskGroupSolutionScoreIds ? props.examTaskGroupSolutionScoreIds : []);
  }, [props.isDisabled]);

  useEffect(() => {
    if (props.buttonType === 'single') {
      const sendbackShortcutListener = (event: KeyboardEvent) => {
        if (event.ctrlKey && event.key === 'Enter') {
          handleClick();
        }
      };
      document.addEventListener('keydown', sendbackShortcutListener);
      return () => {
        document.removeEventListener('keydown', sendbackShortcutListener);
      };
    }
  }, [props.buttonType, props.examTaskGroupSolutionScoreIds]);

  return (
    <TooltipOne title={getTooltipTitle()} placement="bottom-start">
      <div>
        <ButtonOne
          style={
            props.buttonType === 'single'
              ? { width: '80px', minWidth: '95px', backgroundColor: '#347F42' }
              : { backgroundColor: '#347F42' }
          }
          color="inherit"
          variant="contained"
          disabled={props.isDisabled}
          className={props.isDisabled ? classes.disableButton : classes.activeButton}
          endIcon={!props.isDisabled ? <ArrowForward /> : undefined}
          onClick={handleClick}
        >
          {buttonText}
        </ButtonOne>
      </div>
    </TooltipOne>
  );
};

export default SendbackRGZButton;
